import React from "react";

class ButtonComponent extends React.Component {
  render() {
    return (
      <div>
        <button className="bg-xgreen w-48 py-3 rounded-3xl mb-3 text-white" id="submit" onClick={this.props.onClick}>
          Generate Report
        </button>
      </div>
    );
  }
}

export default ButtonComponent;
